import React from 'react';
import { ConferenceAffiliation } from '../../types/conferenceHistory';

interface ConferenceHistoryTableProps {
  affiliations: ConferenceAffiliation[];
  sportLabel: string;
  onEdit: (row: ConferenceAffiliation) => void;
}

function formatEndYearCell(endYear: number | null): string {
  const currentYear = new Date().getFullYear();
  if (endYear === null || endYear >= currentYear) {
    return 'Present';
  }
  return String(endYear);
}

function displayText(value: string | null | undefined) {
  if (value === null || value === undefined || String(value).trim() === '') {
    return '—';
  }
  return String(value).trim();
}

function ConferenceHistoryTable({
  affiliations,
  sportLabel,
  onEdit,
}: ConferenceHistoryTableProps) {
  if (affiliations.length === 0) {
    return (
      <div className="rounded-[22px] border border-dashed border-slate-300 bg-slate-50 px-6 py-10 text-center text-sm text-slate-500">
        No conference history is available for {sportLabel} yet.
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-[22px] border border-slate-200 bg-white shadow-[0_20px_44px_-38px_rgba(15,23,42,0.5)]">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-slate-200 text-left text-sm">
          <thead className="bg-slate-50">
            <tr>
              <th className="whitespace-nowrap px-5 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
                Start year
              </th>
              <th className="whitespace-nowrap px-5 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
                End year
              </th>
              <th className="px-5 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
                Conference name
              </th>
              <th className="px-5 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
                Short name
              </th>
              <th className="px-5 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {affiliations.map((row) => (
              <tr key={row.id} className="hover:bg-slate-50/80">
                <td className="whitespace-nowrap px-5 py-4 font-medium text-[#16233d]">
                  {row.startYear}
                </td>
                <td className="whitespace-nowrap px-5 py-4 font-medium text-[#16233d]">
                  {formatEndYearCell(row.endYear)}
                </td>
                <td className="px-5 py-4 text-[#60718f]">{displayText(row.conferenceName)}</td>
                <td className="px-5 py-4 text-[#60718f]">{displayText(row.conferenceTidyName)}</td>
                <td className="px-5 py-4">
                  <button
                    type="button"
                    onClick={() => onEdit(row)}
                    className="text-sm font-semibold text-sky-600 hover:text-sky-800"
                  >
                    Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ConferenceHistoryTable;
